import { errorValidation } from './utils';

let contactTelInput = $("#contact_phone");

contactTelInput.intlTelInput({
    initialCountry: 'it',
    placeholderNumberType: 'aggressive',
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js",
    separateDialCode: true,
    preferredCountries: ["it"],
    onlyCountries: ["ro", "de", "us", "md", "it"]
}).inputmask({
    mask: "V9999999",
    definitions: {
        "V": {
            validator: "^[1-9][0-9]*$",
        }
    }
});

// on blur: validate
contactTelInput.focusout(function () {
    if ($.trim(contactTelInput.val())) {
        if (contactTelInput.intlTelInput("isValidNumber")) {
            console.log(window.translations.phoneInvalid);
        } else {
            contactTelInput.addClass("_error");
        }
    }
});

// on keydown: reset
contactTelInput.keydown(function () {
    contactTelInput.removeClass("_error");
});


$.validator.addMethod('validateContactPhone', function () {
    if (contactTelInput.intlTelInput("isValidNumber")) {
        return true;
    } else {
        return false;
    }
}, window.translations.phoneInvalid);

(() => {
    const $form = $("form[name='contact']");
    $form.validate({
        ignore: [],
        ...errorValidation,
        errorClass: 'label-error',
        rules: {
            'contact[name]': {
                required: true,
            },
            'contact[phone]': {
                required: true,
                validateContactPhone: true
            },
            'contact[message]': {
                required: true,
            },
        },
        messages: {
            'contact[name]': {
                required: window.translations.required,
            },
            'contact[phone]': {
                required: window.translations.required,
                validateContactPhone: window.translations.phoneInvalid,
            },
            'contact[message]': {
                required: window.translations.required,
            },
        },
        submitHandler: (form) => {
            form.submit();
        },
        success: function (label) {
            let name = label.attr('for');
            label.text('');
        },
    });
})();
